import React from 'react';

import cx from 'classnames';
import { Avatar } from 'antd';

import { getUserInitials } from '../../../common/utils/string';

import styles from './index.module.scss';

export interface IPillProps {
  firstName: string;
  lastName: string;
  className?: string;
}

const Pill: React.FC<IPillProps> = ({ firstName, lastName, className }) => {
  const initials = getUserInitials({ firstName, lastName });
  return (
    <div className={cx(styles.pill, className)}>
      <Avatar size={16} className={styles.avatar}>{initials}</Avatar>
      <div className={styles.fullname}>{firstName} {lastName}</div>
    </div>
  );
};

export { Pill };
